module.exports = __webpack_public_path__ + "static/media/elcano_7.1184bb6b.png";